import React, { useState, useRef, useEffect, useContext } from 'react';
import { colorBrandObject } from '../../../../constants/brandings';
import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Popover, Typography, Box, MenuItem, Select, Divider, Autocomplete, TextField } from "@mui/material";
import CustomButton from '../../../reusableComponents/CustomButton';
import { useAuth } from '../../../context/API_Client';
import { debounce, isEmpty } from '../../utils/utils';
import CloseIcon from '@mui/icons-material/Close';
import GenericReconContext from '../../../context/genericRecon.context';
import { useParams } from 'react-router-dom';
import { customToast } from '../../../reusableComponents/customToaster/customToast';

const selectStyle = {
    fontFamily: "Poppins",
    fontSize: "1rem",
    fontWeight: 300,
    // height: "32px",
    // color: "var( --character-title-85, rgba(0, 0, 0, 0.85))",
    width: "100%",
}

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

const Filter = ({ entityName }) => {
    const { selectedFilters, setSelectedFilters } = useContext(GenericReconContext);
    const { getGenericReconciliationVisualizationData } = useAuth();
    const { reconId } = useParams();
    const [loadingFieldValues, setLoadingFieldValues] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedField, setSelectedField] = useState(null);
    const [filterValueList, setFilterValueList] = useState([]);
    const currentSelcteField = useRef();
    const currentFilterValueRef = useRef([]);
    const isFieldValueMultiselect = false;
    const [selectFieldValueList, setSelectFieldValueList] = useState(isFieldValueMultiselect ? [] : null);
    const arrowRef = useRef();

    const reconConfig = JSON.parse(localStorage.getItem("recon-config"));
    const dashboardFilterFields = reconConfig?.find(d => d.reconId === reconId)?.dashboardFilterFields;

    const getDashboardFilterData = (attribute, callback) => {
        setLoadingFieldValues(true)
        let req = {}
        if (!isEmpty(attribute)) {
            req.advancedAttributeFilters = [attribute]
        }
        getGenericReconciliationVisualizationData(`${entityName}/dashboard/filters`,
            reconId,
            req,
            handleSuccessFilterData,
            handleErrorFilterData
        )
        function handleSuccessFilterData(resp) {
            if (isEmpty(resp[0]?.filterValues)) {
                setLoadingFieldValues(false);
            }
            setFilterValueList(resp[0]?.filterValues.sort((a, b) => a.name.localeCompare(b.name)) || []);
            if (typeof callback === 'function') {
                callback(resp);
            }
        }
        function handleErrorFilterData(err) {
            customToast("error", "high", err);
            setLoadingFieldValues(false)
        }
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedField(null);
        setSelectFieldValueList(isFieldValueMultiselect ? [] : null); //reset selected field value
    };

    const handleFieldChange = (value) => {
        setSelectedField(value);
        setSelectFieldValueList(isFieldValueMultiselect ? [] : null); //reset selected field value
        let id = Date.now();
        currentSelcteField.current = { field: value, id };
        let req = {
            attrName: `fields.${currentSelcteField.current?.field}`,
            operator: "containsIgnoreCase",
            values: ['']
        }
        return getDashboardFilterData(req);
    }

    const handleFieldValueChange = (value, type) => {
        if (isEmpty(value) || value === 'undefined') {
            setSelectFieldValueList(null);
            setLoadingFieldValues(false);
            currentFilterValueRef.current = [];
            return
        }
        setSelectFieldValueList(value);
        let fieldValueData = value;
        if (!isFieldValueMultiselect) {
            fieldValueData = [value];
        }
        if (Array.isArray(fieldValueData)) {
            let tempArr = fieldValueData.map(d => {
                return {
                    fieldValue: d.name,
                    field: currentSelcteField.current?.field,
                    id: `${d.name.replace(' ', '_')}_${currentSelcteField.current?.field.replace(' ', '_')}`
                }
            });
            return currentFilterValueRef.current = tempArr;
        }
        currentFilterValueRef.current = { fieldValue: value, ...currentFilterValueRef.current };
    }

    const handleFieldValueInput = (value) => {
        if (isEmpty(value) || value === 'undefined') {
            setLoadingFieldValues(false);
            return
        }
        let req = {
            attrName: `fields.${currentSelcteField.current?.field}`,
            operator: "containsIgnoreCase",
            values: [value]
        }
        return getDashboardFilterData(req);
    }

    const debouncedHandleFieldValueInput = debounce(handleFieldValueInput, 500);

    const handleApply = () => {
        let data = currentFilterValueRef.current;
        let allFilterListArr = [...selectedFilters];
        data.forEach(d => {
            let i = selectedFilters.findIndex(m => m.field === d.field && m.fieldValue === d.fieldValue);
            if (i === -1) {
                allFilterListArr.push(d);
            }
        });
        setSelectedFilters([...allFilterListArr]);
        setFilterValueList([]);
        setSelectFieldValueList(isFieldValueMultiselect ? [] : null);
        setAnchorEl(null);
        setSelectedField(null);
    }

    const removeFiltersClick = (id) => {
        let filteredData = selectedFilters.filter(d => d.id !== id);
        setSelectedFilters([...filteredData])
    }

    const open = Boolean(anchorEl);
    const id = open ? "popover-with-arrow" : undefined;

    return (
        <div className="filter-container">
            <div className='filter-value-container'>
                {
                    !isEmpty(selectedFilters) && selectedFilters.map(d => (
                        <div className='filter-value' key={d.id}>
                            <Typography className='filter-value-text font-black-high'
                            // style={{ color: colorBrandObject?.primaryButtonColor }}
                            >
                                <Tooltip title={`${d.field}: ${d.fieldValue}`} placement="top" arrow>
                                    {d.field}{': '}{d.fieldValue}
                                </Tooltip>
                            </Typography>
                            <CloseIcon sx={{ fontSize: 16 }} onClick={() => removeFiltersClick(d.id)} />
                        </div>
                    ))
                }
                {dashboardFilterFields?.length > 0 && <Typography className="subHeaderSemiBold tabHeading"
                    onClick={handleClick}
                    sx={{
                        cursor: 'pointer',
                        fontSize: "16px !important",
                        fontWeight: "500 !important",
                        color: `${colorBrandObject?.primaryButtonColor} !important`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <AddIcon />
                    <span>Add Filters</span>
                </Typography>}
            </div>
            {
                open && (
                    <>
                        {/* <Box
                        ref={arrowRef}
                        sx={{
                            position: "absolute",
                            bottom: 0,
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: '1301',
                            "&::after": {
                                content: '""',
                                position: "absolute",
                                borderLeft: "8px solid transparent",
                                borderRight: "8px solid transparent",
                                borderBottom: "8px solid white", // Border color
                                top: 2, // Shift up to align border
                                left: "-8px",
                            },
                            "&::before": {
                                content: '""',
                                position: "absolute",
                                borderLeft: "10px solid transparent",
                                borderRight: "10px solid transparent",
                                borderBottom: "10px solid #eee", // Matches Popover background
                                left: "-10px",
                            },
                        }}
                    /> */}

                    </>
                )
            }
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                sx={{
                    "& .MuiPaper-root": {
                        position: "relative",
                        maxWidth: '500px',
                        minWidth: '400px',
                        mt: -1, // Adjust for arrow spacing
                        backgroundColor: "transparent !important", // Ensure background color
                        boxShadow: 'none',
                        padding: '1rem'
                    },
                }}
            >
                <Box style={{
                    backgroundColor: 'white',
                    boxShadow: "0px 4px 8px -3px #eee",
                    border: "2px solid #eee",
                    borderRadius: "12px",
                    position: "relative",
                }}
                >
                    <div>
                        <div className='header px-4 py-4'>
                            <Typography className='subHeaderSemiBold tabHeading'>
                                Add Filter
                            </Typography>
                        </div>

                        <Divider />

                        <div className='px-4 py-4'>
                            <div className='mb-4'>
                                <div className='mb-2'>
                                    Field*
                                </div>

                                <Select
                                    onChange={(e) => handleFieldChange(e.target.value)}
                                    sx={selectStyle}
                                    value={selectedField}
                                    renderValue={(selected) =>
                                        selected ? (selected) : (<span style={{ color: "#ccc" }}>Select Field</span>)
                                    }
                                    displayEmpty
                                >
                                    {
                                        dashboardFilterFields?.map(m => (
                                            <MenuItem key={m} value={m}>{m}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </div>

                            <div className='mb-4'>
                                <div className='mb-2'>
                                    Field Value*
                                </div>
                                <Autocomplete
                                    disabled={isEmpty(selectedField)}
                                    className="multiselect"
                                    multiple={isFieldValueMultiselect}
                                    limitTags={2}
                                    options={filterValueList}
                                    getOptionLabel={(option) => option.name}
                                    renderOption={(props, option, { selected }) => (<li {...props}>{option?.name}</li>)}
                                    isOptionEqualToValue={(option, value) => option.name === value.name}
                                    value={selectFieldValueList}
                                    onChange={(e, newValue) => handleFieldValueChange(newValue, 'change')}
                                    onInputChange={(e, newValue, reason) => {
                                        if (e && e?.type === 'change') { // Only triggers when typing
                                            setLoadingFieldValues(true)
                                            debouncedHandleFieldValueInput(newValue, 'input');
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" placeholder="Type Field Value" />
                                    )}
                                    ListboxProps={{
                                        style: {
                                            maxHeight: '180px',
                                            overflowY: 'auto',
                                        },
                                    }}
                                    noOptionsText={loadingFieldValues ? "Loading..." : "No options"}
                                />
                            </div>
                        </div>

                        <div className='footer px-4 py-3'>
                            <CustomButton
                                text={"Cancel"}
                                variant={"outlined"}
                                type={"secondary"}
                                size={"sm"}
                                onClick={handleClose}
                            />
                            <CustomButton
                                disabled={isEmpty(selectFieldValueList)}
                                text={"Apply"}
                                variant={"contained"}
                                type={"secondary"}
                                size={"sm"}
                                onClick={handleApply}
                            />
                        </div>
                    </div>
                </Box>
            </Popover>
        </div>
    )
}

export default Filter